import { Flex, Text } from '@chakra-ui/react';

import { CookieKeys, useCookie } from '../hooks/useCookie';
import usePrivacyChoicesInScope from '../hooks/usePrivacyChoicesInScope';
import { PrivacyOptOutValue } from '../utils/privacy';

const GpcOptOutBanner = () => {
  const isInScope = usePrivacyChoicesInScope();
  const [optOut] = useCookie<PrivacyOptOutValue>(CookieKeys.PRIVACY_OPTOUT);

  if (!isInScope || !optOut?.optedOut || optOut.source !== 'gpc') {
    return null;
  }

  return (
    <Flex
      as="aside"
      role="status"
      w="100%"
      minH="32px"
      bg="leaseEndBlue"
      align="center"
      justify="center"
      px={4}
      py={1}
    >
      <Text color="white" fontSize={{ base: '12px', md: '14px' }} textAlign="center">
        Based on your browser's privacy settings, we've opted you out of the sale or sharing of your
        personal information.
      </Text>
    </Flex>
  );
};

export default GpcOptOutBanner;
